// API 相关常量定义

// API 基础URL
if (!import.meta.env.VITE_API_BASE) {
  console.error('[config] VITE_API_BASE is not set — API calls will fail');
}
export const API_BASE = import.meta.env.VITE_API_BASE ?? '';

// API 端点
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    LOGIN: '/system/auth/login',
    LOGOUT: '/system/auth/logout',
    REGISTER: '/system/user/register',
    FORGOT_PASSWORD: '/system/user/forget/password',
    REFRESH_TOKEN: '/system/auth/refresh',
  },
  
  // 用户相关
  USER: {
    PROFILE: '/system/user/profile',
    UPDATE_PROFILE: '/system/user/profile',
    UPDATE_AVATAR: '/system/user/avatar',
    CREATE: '/user/create',
    LIST: '/system/user/search',
    DETAIL: '/system/user',
    UPDATE: '/system/user',
    DELETE: '/system/user',
  },
  
  // PMS 系统相关
  PMS: {
    COMMENTS: '/pms/comments',
    LOCATION_TRACKING: '/pms/location-tracking',
    GEOFENCE: '/pms/geofence',
  },
  
  // 房产管理
  PROPERTY: {
    LIST: '/pms/properties',
    DETAIL: '/pms/properties',
    CREATE: '/pms/properties',
    UPDATE: '/pms/properties',
    DELETE: '/pms/properties',
  },
  
  // 预订管理
  RESERVATION: {
    LIST: '/pms/reservations',
    DETAIL: '/pms/reservations',
    CREATE: '/pms/reservations',
    UPDATE: '/pms/reservations',
    DELETE: '/pms/reservations',
  },
  
  // 访客管理
  GUEST: {
    LIST: '/pms/guests',
    DETAIL: '/pms/guests',
    CREATE: '/pms/guests',
    UPDATE: '/pms/guests',
    DELETE: '/pms/guests',
  },
  
  // 业主管理
  OWNER: {
    LIST: '/pms/owners',
    DETAIL: '/pms/owners',
    CREATE: '/pms/owners',
    UPDATE: '/pms/owners',
    DELETE: '/pms/owners',
  },
  
  // 任务管理
  TASK: {
    LIST: '/pms/tasks',
    DETAIL: '/pms/tasks',
    CREATE: '/pms/tasks',
    UPDATE: '/pms/tasks',
    DELETE: '/pms/tasks',
  },
  
  // 意向管理
  INTENT: {
    LIST: '/pms/intents',
    DETAIL: '/pms/intents',
    CREATE: '/pms/intents',
    UPDATE: '/pms/intents',
    DELETE: '/pms/intents',
  },
} as const;

// HTTP 状态码
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
} as const;

// 请求超时时间（毫秒）
export const REQUEST_TIMEOUT = {
  DEFAULT: 15000,
  UPLOAD: 60000,
  DOWNLOAD: 30000,
} as const;

// 分页默认值
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  DEFAULT_PAGE: 1,
} as const;

// 文件上传相关
export const UPLOAD = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
} as const;

// 缓存相关
export const CACHE = {
  TOKEN_EXPIRY_BUFFER: 5 * 60 * 1000, // 5分钟
  USER_PROFILE_CACHE_TIME: 30 * 60 * 1000, // 30分钟
} as const; 